export default __webpack_public_path__ + "static/media/Kastell.afc73117.png";